import React from 'react';
import { Link } from 'react-router-dom';
import '../styles.css';

const NotFoundPage = () => {
    return (
        <main className="notfound-container">
            <div className="notfound-content">
                <h1 className="notfound-title">404</h1>
                <h2 className="notfound-subtitle">You’ve wandered into the void...</h2>
                <p className="notfound-text">
                    This page might have vanished like Atlantis, taken a wrong turn in the matrix, or simply never existed.
                </p>
                <p className="notfound-text">Try using the search bar, or just go back to safer ground.</p>
                <Link to="/" className="notfound-link">
                    🏠 Take me home
                </Link>
                <p className="notfound-text small-text">
                    (Or refresh the page and hope for a miracle.)
                </p>
            </div>
        </main>
    );
};

export default NotFoundPage;
